import { CharityData } from "@/api/Charities"
import Heading4 from "@/components/text/Heading4"
import Image from "next/image"
import Link from "next/link"
import NewsReelArticleLogos from "../charity/components/NewsReelArticleLogos"

type CharityBundleCardProps = React.LinkHTMLAttributes<HTMLAnchorElement> & {
  post: CharityData
}
const CharityBundleCard: React.FC<CharityBundleCardProps> = ({ post, ...rest }) => {
  return (
    <Link key={post.id} href={`goede-doelen/${post.slug ?? post.id}`} {...rest}>
      <article className="flex flex-col items-start justify-start">
        <div className="md:pb-[1rem] h-[18.7rem] relative w-full mb-[1.5rem]">
          <Image
            fill
            alt={`image for charity bundle ${post.name}`}
            src={post.banner}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="aspect-video w-full rounded-xl bg-gray-100 object-cover aspect-[3/2]"
          />
        </div>
        <div className="w-full">
          <Heading4>{post.name}</Heading4>
          <NewsReelArticleLogos items={post.bundle_charities} />
        </div>
      </article>
    </Link>
  )
}

export default CharityBundleCard
